import { useState } from 'react';
import Iconify from 'src/components/Iconify';
import TableActionButton from 'src/components/TableActionButton';
import UseExistingPolicyModal from './UseExistingPolicyModal';

const UseExistingPolicyAction = () => {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  return (
    <>
      <TableActionButton
        variant="outlined"
        onClick={() => setOpen(true)}
        startIcon={<Iconify icon="mdi:shield-search" width={16} height={16} />}
        sx={{ px: 1.5 }}>
        Use Existing Policy
      </TableActionButton>
      <UseExistingPolicyModal open={open} onDone={close} onClose={close} />
    </>
  );
};

export default UseExistingPolicyAction;
